export default function getTokenFromCookies() {
  if (!document.cookie) {
    return null;
  }

  const cookies = document.cookie.split(";").reduce((acc, item) => {
    acc[item.split("=")[0].trim()] = item.split("=")[1].trim();
    return acc;
  }, {});

  if (cookies.token) {
    return cookies.token;
  } else {
    return null;
  }
}
